
import TrackingEventReport from "../../TrackingEventReport";

import AllTrackingStatusesServiceModule from "../../../services/AllTrackingStatusesService";

const mLogSvc = new WeakMap();
const mAllTrackingStatusesSvc = new WeakMap();

class TrackingEventReportFactory {
    constructor($log, AllTrackingStatuses) {
        if ($log != null) {
            mLogSvc.set(this, $log);
        }
        else {
            throw new Error("Invalid or missing log service");
        }

        if (AllTrackingStatuses != null) {
            mAllTrackingStatusesSvc.set(this, AllTrackingStatuses);
        }
    }

    //Returns static non-DI creation function, so we don't have to keep two lists of constructor params in two different files.
    //Invoked as Create()(...)
    Create() {
        return TrackingEventReport.Create(mLogSvc.get(this));
    }

    FromServerTrackingEventReport(serverReport) {

        let preFiledStatus = null;

        if ((angular.isDefined(serverReport.PreFiledStatus)) &&
            (serverReport.PreFiledStatus != null))
        {
            let preFiledTrackingStatus =
                mAllTrackingStatusesSvc.get(this).getFromId(serverReport.PreFiledStatus);

            if (angular.isDefined(preFiledTrackingStatus))
            {
                preFiledStatus = preFiledTrackingStatus;
            }
        }

        return new TrackingEventReport(
            mLogSvc.get(this),
            serverReport.TrackingEventId,
            serverReport.Report,
            serverReport.ReportUpdated,
            serverReport.ReportFiled,
            preFiledStatus
        );
    }


}

TrackingEventReportFactory.$inject = [ "$log", "AllTrackingStatuses" ];

TrackingEventReportFactory.dependencies = [
    AllTrackingStatusesServiceModule
];

export default TrackingEventReportFactory;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/tracking-event-factories/TrackingEventReportFactory.js
// module id = 7SLI
// module chunks = 1